module.exports = __webpack_public_path__ + "assets/images/project/constituencies/sembawang-grc.jpg?v=063ccc10";